export enum BSDashboardTabEnum {
  ICCONSTRUCTION,
  BIOSOURCE,
}
